import {DojoTemplates} from './DojoTemplates.js';

class SelectList {
	constructor(el) {
		this.el = el;
	}
	add(value, display) {
		let s = document.createElement(`span`);
		s.innerHTML = display;
		s.setAttribute(`data-value`, value);
		s.addEventListener(`click`, evt=>{
			evt.preventDefault();
			this.el.dispatchEvent(new CustomEvent(`select-item-selected`, {
				composed: true,
				bubbles: false,
				detail: value,
			}));
		});
		this.el.appendChild(s);
	}
	empty() {
		this.el.innerHTML = ``;
	}
}

class AutoComplete extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates(`AutoComplete`);
		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);

		this._searchingFor = false;

		this.$.input.addEventListener(`keyup`, evt=>this.keyDown(evt));
		this.selectList = new SelectList(this.$.items);

		this.$.items.addEventListener(`select-item-selected`, evt=>{
			console.log(`selected item: `, evt.detail);
			this.$.input.value = evt.detail;
			this.postInput();
		});
	}
	connectedCallback() {
	}
	keyDown(evt) {
		if (evt.keyCode==13) {
			evt.preventDefault();
			this.postInput();
			return;
		}
		if (3<this.$.input.value.length) {
			this.searchFor(this.$.input.value);
		} else {
			this.selectList.empty();
		}
	}
	postInput(data=null) {
		let input = this.$.input.value.trim();
		if (``==input) return;

		console.log(`TODO : Post accepted input `, this.$.input.value);
		this.dispatchEvent(new CustomEvent(`auto-complete-entry`, {
			composed: true,
			bubbles: true,
			detail: {
				entry: this,
				value: this.$.input.value,
				data: data
			},
		}));

		// clean up for next entry
		this.$.input.value=``;
		this.selectList.empty();
		this.$.input.focus();
	}
	// searchFor searches for terms that might match the given input.
	// The actual operation of this search is up to the user, who
	// should provide an ID of a component that will provide a 
	// searchFor(string) input that will return an array of matching values,
	// of which the FIRST value must be the search string.
	searchFor(input) {
		this._searchingFor = input;
		let provider = document.getElementById(this.getAttribute(`data-provider-id`));
		if (!provider) {
			console.error(`No [data-provider-id = #${this.getAttribute(`data-provider-id`)})}] element found to provide search results`);
		}
		provider.searchFor(input)
		.then( (arr)=>{
			if (arr[0]!=this._searchingFor) {
				console.log(`discarding results of searchFor because another search has begun.`);
				return;
			}
			arr.splice(0,1);
			this.selectList.empty();
			for (let i of arr) {
				this.selectList.add(i, i);
			}
		})
		.catch(err=>console.error(err));
	}
}
customElements.define(`dojo-auto-complete`, AutoComplete);